import { Firestore, Storage, FirestoreRef } from '../../config/firebase'
import FirebaseResults from './firebase_results'

const FirebaseTasks = Firestore.collection('tasks')
const FirebaseSubTasks = Firestore.collection('subtasks')
//const FirebaseSubTasks = Firestore.collectionGroup('subtasks')

const StoragePhotos = Storage.ref().child('photos')
const FirebaseAgents = Firestore.collection('agents')
const FirebaseProjects = Firestore.collection('projects')

export { FirebaseTasks, FirebaseSubTasks, FirebaseResults, StoragePhotos, FirebaseAgents, FirestoreRef, FirebaseProjects } 